import React, { useState, useEffect, Fragment } from 'react';
import VignetteBL from './VignetteBL';
import ReactLoading from 'react-loading';

// Inject script to enable video APi
VignetteBL.VignetteVideoApiScriptEnable();

const VignetteArticle = (props) => {
    const { articleId, renderVideo, loaderComponent, videoPosition } = props;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetching the article
        VignetteBL.fetchArticle(articleId, data => {
            VignetteBL.injectArticle(
                'vignette-article-header',
                'vignette-article-body',
                'vignette-video-container',
                data,
                setLoading,
                renderVideo,
                videoPosition,
                injectVideoPositonTopOrBottom
            );
        });

        //Impure function, works on the prop: videoPosition
        function injectVideoPositonTopOrBottom(videoId, videoNode) {
            if (!videoPosition) return;
            VignetteBL.injectVideo(videoId, videoNode);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);




    const styles = {
        loaderStyle: {
            width: '130px',
            height: '130px',
            color: '#000000',
            margin: '0 auto'
        }
    }

    return (
        <Fragment>
            {loading ?
                loaderComponent || <ReactLoading type={"spinningBubbles"} style={styles.loaderStyle} />
                :
                <section className="vignette-article-container">
                    <div className="vignette-article-header" />

                    {/* Optionally for rendering video on top */}
                    {videoPosition === "top" && <div className="vignette-video-container" />}

                    <div className="vignette-article-body" />

                    {/* Optionally for rendering video on bottom */}
                    {videoPosition === "bottom" && <div className="vignette-video-container" />}
                </section>
            }
        </Fragment>
    )
}

export default VignetteArticle



// WEBPACK FOOTER //
// ./src/Vignette/VignetteArticle.jsx